<template>
  <a-card :bordered="false" :headStyle="{ fontSize: '18px' }">
    <search-page-view
      :col="3"
      ref="pageList"
      :itemNames="['search_orderNo', 'search_date']"
      :columns="columns"
      :queryParams="queryParams"
      row-key="id"
      :leftSpace="20"
      :requestPromise="loadPromise"
    >
      <a-form-item slot="search_orderNo" label="工单ID" v-bind="searchItemLayout">
        <a-input v-model="queryParams.invoiceId" placeholder="请输入"></a-input>
      </a-form-item>
      <a-form-item slot="search_date" label="申请日期" v-bind="searchItemLayout">
        <a-range-picker style="width: 100%;" format="YYYY-MM-DD" @change="onChange"/>
      </a-form-item>
      <span slot="action" slot-scope="rowItem">
        <a @click="toHistory(rowItem.record.id)">查看详情</a>
      </span>
    </search-page-view>
  </a-card>
</template>

<script>
import searchForm from '../../../utils/mixins/searchFormMixins'

export default {
  name: 'InvoiceHistory',
  mixins: [searchForm],
  data() {
    return {
      searchItemList: ['search_nickName', 'search_source'],
      queryParams: {},
      loadPromise: params => this.getDataList(params),
      columns: [
        {
          title: '工单ID',
          dataIndex: 'id'
        },
        {
          title: '申请时间',
          dataIndex: 'createTime'
        },
        {
          title: '开票金额',
          dataIndex: 'invoiceAmount'
        },
        {
          title: '订单数量',
          dataIndex: 'orderNum'
        },
        {
          title: '支持发票类型',
          dataIndex: 'invoiceTypeStr'
        },
        {
          title: '状态',
          dataIndex: 'statusStr'
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ]
    }
  },
  methods: {
    toHistory(id) {
      this.$router.push({
        name: 'HistoricalDetails',
        query: {
          id: id
        }
      })
    },
    getDataList(params) {
      return this.getHttpServices()
        .getCloudUserService()
        .post('invoice/v2/getInvoiceList', params)
    },
    //日期传参
    onChange(value, dateString) {
      this.queryParams.createStartTime = dateString[0]
      this.queryParams.createEndTime = dateString[1]
    }
  }
}
</script>

<style scoped>
</style>